import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "v2_table_paging_next",
  "use": "v2_table_paging_next-usage",
  "viewBox": "0 0 6 10",
  "content": "<symbol viewBox=\"0 0 6 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"v2_table_paging_next\">\n<path d=\"M1.25 9.0835L5 5.3335L1.25 1.5835\" stroke=\"#9B9B9B\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol